export default __webpack_public_path__ + "img/bUvdkdVB.1213116d.svg";